import { VStack } from '@chakra-ui/react';
import type React from 'react';
import EU_BG from '../../assets/europe.svg';
import { HomeHeading } from './HomeHeading';
import DemoTeamList from './DemoTeamList';
import { HOME_DEMO_10_TEAMS } from './homeDemoExample';

const PredictSection: React.FC = () => {
  return (
    <VStack w='full' maxW='full' m='auto' justifyContent='center' bgImage={EU_BG} bgSize='contain' bgPos='top'>
      <HomeHeading mb='1em'>1. Predict the Best 10 Teams at the World Cup 2026</HomeHeading>
      <DemoTeamList teams={[...HOME_DEMO_10_TEAMS]} />
    </VStack>
  );
};

export default PredictSection;
